import React from 'react';
import { CheckCircle2, Mail, Download, Moon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function ThankYouPage() {
  return <div className="min-h-screen flex flex-col bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-599">
      <main className="flex-grow flex items-center justify-center py-16 px-4" data-id="element-600">
        <div className="max-w-3xl w-full mx-auto text-center" data-id="element-601">
          {/* Success Icon */}
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-success/10 mb-8" data-id="element-602">
            <CheckCircle2 size={48} className="text-success" data-id="element-603" />
          </div>

          {/* Headlines */}
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-forest mb-6" data-id="element-604">
            ¡Felicidades! Tu Pedido Está Confirmado
          </h1>
          <p className="text-xl md:text-2xl text-dark/80 font-medium mb-12" data-id="element-605">
            Tu acceso completo ha sido enviado a tu correo electrónico.
          </p>

          {/* Next Steps Card */}
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-warm border border-gold/20 text-left mb-12 relative overflow-hidden" data-id="element-606">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-forest via-gold to-forest" data-id="element-607"></div>

            <h2 className="font-serif text-2xl md:text-3xl font-bold text-forest mb-8 text-center" data-id="element-608">
              Tus Próximos Pasos:
            </h2>

            <div className="space-y-8" data-id="element-609">
              {/* Step 1 */}
              <div className="flex items-start gap-6" data-id="element-610">
                <div className="w-12 h-12 rounded-full bg-forest/10 flex items-center justify-center shrink-0" data-id="element-611">
                  <Mail size={24} className="text-forest" data-id="element-612" />
                </div>
                <div data-id="element-613">
                  <h3 className="text-xl font-bold text-dark mb-2" data-id="element-614">
                    1. Revisa tu bandeja de entrada
                  </h3>
                  <p className="text-dark/70 leading-relaxed" data-id="element-615">
                    Busca un correo de Hotmart con el asunto "Tu acceso a Cenas
                    Anti-Inflamatorias". Si no lo ves en 5 minutos, revisa tu
                    carpeta de spam o promociones.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-6" data-id="element-616">
                <div className="w-12 h-12 rounded-full bg-forest/10 flex items-center justify-center shrink-0" data-id="element-617">
                  <Download size={24} className="text-forest" data-id="element-618" />
                </div>
                <div data-id="element-619">
                  <h3 className="text-xl font-bold text-dark mb-2" data-id="element-620">
                    2. Descarga tu material
                  </h3>
                  <p className="text-dark/70 leading-relaxed" data-id="element-621">
                    Accede a la plataforma y descarga tu Guía Maestra, el
                    Recetario de 21 Cenas y todos tus bonos exclusivos.
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-6" data-id="element-622">
                <div className="w-12 h-12 rounded-full bg-forest/10 flex items-center justify-center shrink-0" data-id="element-623">
                  <Moon size={24} className="text-forest" data-id="element-624" />
                </div>
                <div data-id="element-625">
                  <h3 className="text-xl font-bold text-dark mb-2" data-id="element-626">
                    3. Comienza esta misma noche
                  </h3>
                  <p className="text-dark/70 leading-relaxed" data-id="element-627">
                    Elige una receta rápida del recetario, aplica el Método de
                    Digestión en Reposo y prepárate para despertar diferente
                    mañana.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Support Section */}
          <div className="bg-forest/5 rounded-xl p-6 border border-forest/10" data-id="element-628">
            <p className="text-dark/80 font-medium" data-id="element-629">
              ¿Tienes algún problema con tu acceso?
            </p>
            <p className="text-dark/60 mt-2" data-id="element-630">
              Escríbenos a{' '}
              <a href="mailto:soporte@ejemplo.com" className="text-forest font-bold hover:underline" data-id="element-631">
                soporte@ejemplo.com
              </a>{' '}
              y te ayudaremos de inmediato.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-632" />
    </div>;
}